import React from 'react';
import PropTypes from 'prop-types';

import RsTableHeaderSortControl from '@Pages/RetroSynthesis/components/RsTable/RsTableHeaderSortControl';
import { mapSortStringToObject } from '@Pages/RetroSynthesis/utils';
import HeaderInfoIcon from '@Pages/RetroSynthesis/ProjectRoutes/components/HeaderInfoIcon';
import HeaderInfoTooltip from '@Pages/RetroSynthesis/ProjectRoutes/components/HeaderInfoTooltip';
import TooltipContentScore from '@Pages/RetroSynthesis/ProjectRoute/ProjectRouteConditions/components/StepDataExamples/TooltipContentScore';
import TooltipContentReaxysExamples from '@Pages/RetroSynthesis/ProjectRoute/ProjectRouteConditions/components/StepDataExamples/TooltipContentReaxysExamples';

import './ExamplesTableHeader.custom.scss';

function ExamplesTableHeader({ sortList, setSortList }) {
  const onSortChange = ({ sort } = {}) => {
    // eslint-disable-next-line no-unused-expressions
    sort && setSortList([mapSortStringToObject(sort)]);
  };

  return (
    <tr className="examples-table-header">
      <th>
        <div className="examples-table-header__item number">
          <RsTableHeaderSortControl sortList={sortList} sortParam="exampleNo" onChange={onSortChange}>
            No
          </RsTableHeaderSortControl>
        </div>
      </th>
      <th>
        <div className="examples-table-header__item">
          <HeaderInfoIcon tooltipId="tooltip-reaxys-examples" />
          <HeaderInfoTooltip id="tooltip-reaxys-examples" rightAlign>
            <TooltipContentReaxysExamples />
          </HeaderInfoTooltip>
          Reaxys Examples
        </div>
      </th>
      <th>
        <div className="examples-table-header__item">
          <HeaderInfoIcon tooltipId="tooltip-examples-score" />
          <HeaderInfoTooltip id="tooltip-examples-score">
            <TooltipContentScore />
          </HeaderInfoTooltip>
          <RsTableHeaderSortControl sortList={sortList} sortParam="score" onChange={onSortChange}>
            Score
          </RsTableHeaderSortControl>
        </div>
      </th>
    </tr>
  );
}

ExamplesTableHeader.defaultProps = {
  setSortList: () => {},
};

ExamplesTableHeader.propTypes = {
  sortList: PropTypes.array,
  setSortList: PropTypes.func,
};

export default ExamplesTableHeader;
